import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { prepareDataForPreview } from '@helps/prepareDataForPreview';

const RenderInlinePreviewItem = (
  label = '',
  value = '',
  labelColumn = 6,
  valueColumn = 18,
  rowGutter = 20,
  withDot = false,
  lineThrough = false
) => {
  const { isValueValid, _value, _label } = prepareDataForPreview({ value, label });

  if (!isValueValid) {
    return null;
  }

  return (
    <Row gutter={rowGutter} className={'text-preview'} key={Math.random()}>
      <Col md={labelColumn}>
        <div className='title'>
          {_label}
          {withDot && _label[_label.length - 1] !== ':' && ':'}
        </div>
      </Col>
      <Col md={valueColumn}>
        <div style={{ textDecoration: lineThrough ? 'line-through' : 'none' }} className={'info'}>
          {_value}
        </div>
      </Col>
    </Row>
  );
};

RenderInlinePreviewItem.propTypes = {
  label: PropTypes.oneOf([PropTypes.string, PropTypes.object]),
  value: PropTypes.oneOf([PropTypes.number, PropTypes.string, PropTypes.bool, PropTypes.array]),
  labelColumn: PropTypes.number,
  valueColumn: PropTypes.number,
  rowGutter: PropTypes.number,
};

export default RenderInlinePreviewItem;
